import type { RouteRecordRaw } from 'vue-router';
import { authRoutes } from '@shared';
import { fertilizerRoutes, mapRoutes, parcelRoutes, planRoutes } from '@maximap-base';
import home from './modules/home/router/routes';
import userProfile from './modules/user-profile/routes/routes';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    children: [
      {
        path: '',
        component: () => import('./components/layouts/HomeLayout.vue'),
        children: [...home, ...authRoutes]
      },
      {
        path: '',
        component: () => import('./components/layouts/MainLayout.vue'),
        children: [...userProfile, ...mapRoutes, ...parcelRoutes, ...planRoutes, ...fertilizerRoutes]
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: () => import('./modules/core/pages/ErrorPage.vue')
  }
];

export default routes;
